import { render, staticRenderFns } from "./route.vue?vue&type=template&id=344a1648"
import script from "./route.vue?vue&type=script&lang=js"
export * from "./route.vue?vue&type=script&lang=js"
import style0 from "./route.vue?vue&type=style&index=0&id=344a1648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports